<template>
  <div class="breadcrumb-content">
    <a-breadcrumb separator=">">
      <a-breadcrumb-item class="pointer"
                         @click="clickBreadcrumbHome">{{ $t('home.Breadcrumb.home') }}</a-breadcrumb-item>
      <a-breadcrumb-item class="pointer"
                         @click="clickBreadcrumb">{{ $t('home.Breadcrumb.breadcrumb') }}</a-breadcrumb-item>
      <a-breadcrumb-item>{{ props.tag }}</a-breadcrumb-item>
    </a-breadcrumb>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'
const props = defineProps(['tag'])
const router = useRouter()
const clickBreadcrumbHome = () => {
  router.push('/home')
}
const clickBreadcrumb = () => {
  router.push('/posts')
}
</script>

<style scoped lang="less">
.breadcrumb-content {
  margin-bottom: 30px;
}

.pointer {
  cursor: pointer;
}
</style>
